<div class="wrapper pdg-bottom">
  <div class="title-section mb-5">{{"Contatti"|translate}}</div>

  <div class="contact-box">

    <div class="title mb-3">
      <!-- <img src="./assets/img/company.svg" width="20" class="mr-2"> -->
      <img src="./assets/img/logo.svg" width="30" class="mr-2">
      <span class="v-middle font-22">SPS s.r.l.</span>
    </div>
    <div class="mb-2">
      <img src="./assets/img/pin.svg" width="20" class="mr-2">
      Corso Unione Sovietica 612/21 - 10135 Torino - TO
    </div>
    <div class="mb-2">
      <img src="./assets/img/phone.svg" title="Telephone" width="20" class="mr-2">
      011 501188 - 011 5099310
    </div>
    <div class="mb-2">
      <img src="./assets/img/cellular.svg" title="Cellular" width="20" class="mr-2">
      334 6504489
    </div>
    <div>
      <img src="./assets/img/email.svg" title="Email" width="20" class="mr-2">
      <a href="mailto:info@spsautomazione.it" target="_blank" class="menu">info@spsautomazione.it</a>
    </div>
  </div>

  <div class="map-wrapper google-maps">
    <iframe 
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2820.565548765345!2d7.618775959594275!3d45.01344369395983!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4788130c92537ce5%3A0x65bc04fb1ac514da!2sCorso+Unione+Sovietica%2C+612%2F21%2C+10135+Torino+TO%2C+Italia!5e0!3m2!1sit!2sus!4v1547195222712"
      width="100%" height="220" frameborder="0" style="border:0" allowfullscreen></iframe>

  </div>

</div>